import { api } from './client';

export async function listClouds() {
  const r = await api.get('/clouds');
  return r.data;
}

export async function getCloud(id) {
  const r = await api.get(`/clouds/${id}`);
  return r.data;
}

export async function createCloud(payload) {
  const r = await api.post('/clouds', payload);
  return r.data;
}

export async function refreshCloud(id) {
  const r = await api.post(`/clouds/${id}/refresh`);
  return r.data;
}

export async function updateCloudCredentials(id, payload) {
  const r = await api.put(`/clouds/${id}/credentials`, payload);
  return r.data;
}

export async function notifyCloud(id, body = {}) {
  const r = await api.post(`/clouds/${id}/notify`, body);
  return r.data;
}

export async function deleteCloud(id) {
  const r = await api.delete(`/clouds/${id}`);
  return r.data;
}

const CloudAPI = { listClouds, getCloud, createCloud, updateCloudCredentials, refreshCloud, notifyCloud, deleteCloud };

export default CloudAPI;

